import { ArrowDown, ArrowUp, BadgeDollarSign, LayoutTemplate, Percent, ScrollText } from "lucide-react";
import { PricingEvent } from "@/store/eventsSlice";

export type ChangeType = 'plans' | 'priceIncrease' | 'priceDecrease' | 'availability' | 'introDiscount' | 'display' | 'All';

export const EVENT_CHANGES = {
  priceIncrease: {
    label: 'Price Increased',
    icon: ArrowUp,
    className: 'bg-green-100 text-green-700 hover:bg-green-200'
  },
  plans: {
    label: 'Plans Changed',
    icon: ScrollText,
    className: 'bg-blue-100 text-blue-700 hover:bg-blue-200'
  },
  priceDecrease: {
    label: 'Price Decreased',
    icon: ArrowDown,
    className: 'bg-red-100 text-red-700 hover:bg-red-200'
  },
  availability: {
    label: 'Availability',
    icon: BadgeDollarSign,
    className: 'bg-purple-100 text-purple-700 hover:bg-purple-200'
  },
  introDiscount: {
    label: 'Intro Discount',
    icon: Percent,
    className: 'bg-yellow-100 text-yellow-700 hover:bg-yellow-200'
  },
  display: {
    label: 'Display Changed',
    icon: LayoutTemplate,
    className: 'bg-gray-100 text-gray-700 hover:bg-gray-200'
  }
};

export const mapCompanyToChanges = (company: {
  plansChanged?: boolean;
  priceIncreased?: boolean;
  priceDecreased?: boolean;
  priceAvailbilityChanged?: boolean;
  introDiscount?: boolean;
  displayChanged?: boolean;
}): Record<string, boolean> => {
  return {
    plansChanged: company.plansChanged || false,
    priceIncreased: company.priceIncreased || false,
    priceDecreased: company.priceDecreased || false,
    priceAvailbilityChanged: company.priceAvailbilityChanged || false,
    introDiscount: company.introDiscount || false,
    displayChanged: company.displayChanged || false
  };
};

export const getEventLabels = (changes: Record<string, boolean>) => {
  return Object.entries(EVENT_CHANGES)
    .filter(([key]) => changes[getChangeAttribute(key)])
    .map(([_, value]) => value);
};

export const getEventLabelsFromEvent = (event: PricingEvent) => {
  const changes = mapCompanyToChanges(event);
  return getEventLabels(changes);
};

export const getChangeAttribute = (changeType: string): string => {
  switch (changeType) {
    case 'plans':
      return 'plansChanged';
    case 'priceIncrease':
      return 'priceIncreased';
    case 'priceDecrease':
      return 'priceDecreased';
    case 'availability':
      return 'priceAvailbilityChanged';
    case 'introDiscount':
      return 'introDiscount';
    case 'display':
      return 'displayChanged';
    default:
      return changeType;
  }
};

export const formatPageLabel = (subslug: string): string => {
  if (!subslug) return 'Main';
  // Remove leading dot if present and capitalize first letter
  const cleanSlug = subslug.startsWith('.') ? subslug.slice(1) : subslug;
  return cleanSlug.charAt(0).toUpperCase() + cleanSlug.slice(1);
};